import TypedEmitter from 'typed-emitter';
import * as Shared from '@shared/lib';
import EventEmitter from 'events';

type MessageEvents = {
  onAbilityTarget: (abilityId: number, targetId: string) => void,
  ammoUpdate: (ammo: number, maxAmmo: number) => void,
  itemDrop: (message: Shared.LootDropMessage) => void,

  needAbilityTarget: (abilityId: number) => void,
  reload: (force: boolean) => void,

  clearAbilityTarget: () => void,

  comboBreak: () => void,
}

export const MessageEmitter = new EventEmitter() as TypedEmitter<MessageEvents>;
